import React, { FunctionComponent } from 'react';
import styles from "../ChatInput.module.scss";
import TypingLoader from "../../../../components/loading/TypingLoader/TypingLoader";
import { useTypedSelector } from "../../../../redux/hooks";
import { useConversationContext } from '../../../../context/ChatContext/contextConvo';
import { selectConversationTypers } from '../../../../redux/slices/chatNSlice';
import { useChatChatter } from '../../../../redux/services/nebulaChat';

interface Props {
}

const TypingUser: React.FC<{ userUuid: string }> = ({ userUuid }) => {
    const chatter = useChatChatter({ userUuid });

    return chatter.name;
}

export const TypingUserList: React.FC<{ users: string[] }> = ({ users }) => {
    switch (users.length) {
        case 0:
            return null;
        case 1:
            return <><TypingUser userUuid={users[0]} />&nbsp;is typing...</>
        case 2:
            return <><TypingUser userUuid={users[0]} />&nbsp;&amp;&nbsp;<TypingUser userUuid={users[1]} />&nbsp;are typing...</>
        case 3:
            return <><TypingUser userUuid={users[0]} />&nbsp;,&nbsp;<TypingUser userUuid={users[1]} />&nbsp;&amp;&nbsp;<TypingUser userUuid={users[2]} />&nbsp;are typing...</>
        default:
            return <><TypingUser userUuid={users[0]} />&nbsp;,&nbsp;<TypingUser userUuid={users[1]} />&nbsp;&amp;&nbsp;{users.length}&nbsp;others are typing...</>
    }
}

const TypingUsers: FunctionComponent<Props> = () => {
    const { conversation, isScrolled } = useConversationContext();

    const typingUsers = useTypedSelector(state => selectConversationTypers(state, conversation.uuid));

    if (!typingUsers || typingUsers.length < 1) return null

    return (
        <div
            className={styles.user_typing}
            data-has-border={isScrolled || null}
        >
            <TypingLoader mini />
            <p><TypingUserList users={typingUsers} /></p>
        </div>
    );
};

export default TypingUsers;
